import { SuccessDialogPlugin } from '@/plugins/GlobalDialog';

export default class SuccessDialogModel {
  public show(message: string, onConfirm: VoidFunction|false = false): void {
    SuccessDialogPlugin.$eventBus.$emit('show-success-dialog', {
      message,
      onConfirm,
    })
  }
}
